import type { SelectGeneric } from "../../modules/casos/types/interfaces/ApiConsultaGestionCasos/Generic";
import type { Entidad } from "../types/interfaces/user.interface";
import URL_API_USER from "../utils/ApiUrl/ApiUsuarios";
import { HTTP } from "./Http.service";

const http = HTTP();

// Interfaces para tipado
export interface UserProfile {
    id: string;
    nombre: string;
    apellidos: string;
    email: string;
    telefono?: string;
    cedula?: string;
    fechaNacimiento?: string;
    direccion?: string;
    tipoUsuario: number;
    estado: boolean;
    fechaCreacion: string;
    fechaModificacion?: string;
}

export interface UserPreferences {
    id: string;
    idUsuario: string;
    idioma: string;
    zona: string;
    notificacionesEmail: boolean;
    notificacionesSMS: boolean;
    temaOscuro: boolean;
}

export interface UserRole {
    id: string;
    nombre: string;
    descripcion: string;
    permisos: string[];
}

export interface UserEntity {
    id: string;
    nombre: string;
    codigo: string;
    tipo: string;
    estado: boolean;
}

export interface UserStats {
    totalCasos: number;
    casosActivos: number;
    casosFinalizados: number;
    audienciasProximas: number;
    documentosPendientes: number;
    notificacionesNoLeidas: number;
}

export interface UpdateUserRequest {
    nombre?: string;
    apellidos?: string;
    email?: string;
    telefono?: string;
    direccion?: string;
}

export interface ChangePasswordRequest {
    passwordActual: string;
    passwordNueva: string;
    confirmarPassword: string;
}

/**
 * Obtiene los datos de la entidad seleccionada vinculada al usuario
 */
async function getInfoEntidad(idUsuario: number, idEntidad: number): Promise<Entidad> {
    const endpoint = `${URL_API_USER.GET_USER_ENTITIES}?idUsuario=${idUsuario}&idEntidad=${idEntidad}`;
    return await http.Get(endpoint);
}

/**
 * Obtiene las entidades a las que esta vinculado un usuario
 */
async function getEntitiesByIdUsuario(idUsuario: number): Promise<any> {
    const endpoint = `${URL_API_USER.GET_ENTITIES_BY_USER_ID}?idUsuario=${idUsuario}`;
    return await http.Get(endpoint);
}

// /**
//  * Actualiza el perfil del usuario autenticado
//  */
// async function updateUserProfile(updateData: UpdateUserRequest): Promise<UserProfile> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/perfil`;
//     return await http.Put(endpoint, { body: updateData });
// }

// /**
//  * Obtiene las preferencias del usuario
//  */
// async function getUserPreferences(idUsuario?: string): Promise<UserPreferences> {
//     const endpoint = idUsuario 
//         ? `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/preferencias`
//         : `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/preferencias`;
//     return await http.Get(endpoint);
// }

// /**
//  * Actualiza las preferencias del usuario
//  */
// async function updateUserPreferences(preferences: Partial<UserPreferences>): Promise<UserPreferences> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/preferencias`;
//     return await http.Put(endpoint, { body: preferences });
// }

// /**
//  * Obtiene los roles asignados a un usuario
//  */
// async function getUserRoles(idUsuario?: string): Promise<UserRole[]> {
//     const endpoint = idUsuario 
//         ? `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/roles`
//         : `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/roles`;
//     return await http.Get(endpoint);
// }

// /**
//  * Obtiene las entidades asociadas al usuario
//  */
// async function getUserEntities(idUsuario?: string): Promise<UserEntity[]> {
//     const endpoint = idUsuario 
//         ? `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/entidades`
//         : `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/entidades`;
//     return await http.Get(endpoint);
// }

// /**
//  * Obtiene estadísticas del usuario (casos, audiencias, documentos, etc.)
//  */
// async function getUserStats(idUsuario?: string): Promise<UserStats> {
//     const endpoint = idUsuario 
//         ? `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/estadisticas`
//         : `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/estadisticas`;
//     return await http.Get(endpoint);
// }

// /**
//  * Cambia la contraseña del usuario autenticado
//  */
// async function changePassword(passwordData: ChangePasswordRequest): Promise<{ success: boolean; message: string }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/cambiar-password`;
//     return await http.Post(endpoint, { body: passwordData });
// }

// /**
//  * Busca usuarios por diferentes criterios
//  */
// async function searchUsers(queryString: string): Promise<UserProfile[]> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/buscar${queryString}`;
//     return await http.Get(endpoint);
// }

// /**
//  * Verifica si un usuario existe por email
//  */
// async function checkUserExists(email: string): Promise<{ exists: boolean; userId?: string }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/verificar-existencia`;
//     return await http.Post(endpoint, { body: { email } });
// }

// /**
//  * Obtiene la lista de usuarios con paginación (para administradores)
//  */
// async function getUsers(queryString: string): Promise<{
//     usuarios: UserProfile[];
//     totalRegistros: number;
//     paginaActual: number;
//     totalPaginas: number;
// }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios${queryString}`;
//     return await http.Get(endpoint);
// }

// /**
//  * Desactiva/activa un usuario (para administradores)
//  */
// async function toggleUserStatus(idUsuario: string, estado: boolean): Promise<{ success: boolean; message: string }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/estado`;
//     return await http.Patch(endpoint, { body: { estado } });
// }

// /**
//  * Obtiene el historial de actividad del usuario
//  */
// async function getUserActivityHistory(idUsuario?: string, queryString: string = ''): Promise<any[]> {
//     const endpoint = idUsuario 
//         ? `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/${idUsuario}/historial-actividad${queryString}`
//         : `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/historial-actividad${queryString}`;
//     return await http.Get(endpoint);
// }

// /**
//  * Sube o actualiza la foto de perfil del usuario
//  */
// async function uploadProfilePhoto(formData: FormData): Promise<{ photoUrl: string; message: string }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/foto-perfil`;
//     return await http.PostByFormData(endpoint, { body: formData });
// }

// /**
//  * Elimina la foto de perfil del usuario
//  */
// async function deleteProfilePhoto(): Promise<{ success: boolean; message: string }> {
//     const endpoint = `${import.meta.env.VITE_API_USUARIOS}/api/usuarios/me/foto-perfil`;
//     return await http.Del(endpoint);
// }

export {
    // Perfil
    getInfoEntidad ,
    getEntitiesByIdUsuario,
    // updateUserProfile,
    
    // // Preferencias
    // getUserPreferences,
    // updateUserPreferences,
    
    // // Roles y Entidades
    // getUserRoles,
    // getUserEntities,
    
    // // Estadísticas
    // getUserStats,
    
    // // Seguridad
    // changePassword,
    
    // // Búsqueda y Administración
    // searchUsers,
    // checkUserExists,
    // getUsers,
    // toggleUserStatus,
    
    // // Actividad
    // getUserActivityHistory,
    
    // // Foto de Perfil
    // uploadProfilePhoto,
    // deleteProfilePhoto
};